import PropTypes from 'prop-types'

import { Header } from '@/components/Page'
import cn from '@/utilities/cn'

import './index.scss'

/**
 * Component to create a two-column layout with the necessary action buttons for the notification publishing process
 */
const TwoColumnLayout = ({ className, leftColumn, rightColumn, backNavTitle, goBack, title, headerIcon }: any) => (
  <div className={cn('two-column-layout', className)}>
    <div className="column-left">{leftColumn}</div>
    <div className="column-right">
      <div className="card-wrapper">
        <div className="column-header">
          {headerIcon && headerIcon}
          {title && <Header backNavTitle={backNavTitle} goBack={goBack} title={title} />}
        </div>
        {rightColumn}
      </div>
    </div>
  </div>
)

TwoColumnLayout.displayName = 'TwoColumnLayout'

TwoColumnLayout.propTypes = {
  backNavTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  goBack: PropTypes.func,
  headerIcon: PropTypes.element,
  leftColumn: PropTypes.node.isRequired,
  rightColumn: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

TwoColumnLayout.defaultProps = {
  backNavTitle: null,
  className: null,
  goBack: () => {},
  headerIcon: null,
  title: null
}

export default TwoColumnLayout
